import { useCallback } from 'react';
import { isEqual } from 'lodash';
import { useFlowBuilder2PageStore } from '../Store/useFlowBuilder2PageStore';

export const useOpenComponent = () => {
  const getActiveComponent = useFlowBuilder2PageStore((s) => s.getActiveComponent);
  const setActiveComponent = useFlowBuilder2PageStore((s) => s.setActiveComponent);

  return useCallback(
    (value: { layoutId: string; componentId: string }) => {
      const activeComponent = getActiveComponent();
      if (!isEqual(value, activeComponent)) setActiveComponent(value);
    },
    [getActiveComponent, setActiveComponent],
  );
};
